import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import { observeAudioRecorders } from '@/utils/audioRecorder'
import '@fortawesome/fontawesome-free/css/all.min.css'

import '@/assets/css/tailwind.css'
import '@/assets/css/main.css'

const pinia = createPinia()
pinia.use(createPersistedState())

const app = createApp(App)

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: 'https://6ca2e560c59a74fb2e7efef0adc4412a@o4507252588544000.ingest.us.sentry.io/4507252590706688',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/hopekit\.ca/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

app.use(pinia)
app.use(router)

app.mount('#app')

// Templates are injected with v-html, so recorder widgets are wired up by
// watching the DOM rather than by each view remembering to do it.
observeAudioRecorders()
